Unit AccountMainForm;

Interface

Uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  MainForm.Base,
  WEBLib.Toast,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Holiday.ReturnTypes,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset;

Type
  TAccountMainPage = Class(TMainBasePage)
    NewBookingLink: TLabel;
    SignOutLink: TLabel;
    MyDetailsLink: TLabel;
    TestServerException: TLabel;
    TestLocalException: TLabel;
    EmergencyDetailsLabel: TLabel;
    AccountGuestDataset: TXDataWebDataSet;
    AccountGuestDatasetGuestId: TIntegerField;
    AccountGuestDatasetCustomerId: TIntegerField;
    AccountGuestDatasetBookingId: TIntegerField;
    AccountGuestDatasetGuestType: TStringField;
    AccountGuestDatasetMedia1: TStringField;
    AccountGuestDatasetMedia2: TStringField;
    AccountGuestDatasetMedia3: TStringField;
    AccountGuestDatasetMedia4: TStringField;
    AccountGuestDatasetExtraNightsCharge: TFloatField;
    AccountGuestDatasetRoomTypeId: TIntegerField;
    AccountGuestDatasetRoomUpgradeDescription: TStringField;
    AccountGuestDatasetIncomplete: TBooleanField;
    AccountGuestDatasetGuestNumber: TIntegerField;
    AccountGuestDatasetEaselRequired: TBooleanField;
    AccountGuestDatasetFoldingChairRequired: TBooleanField;
    AccountGuestDatasetDietaryRequirements: TStringField;
    AccountGuestDatasetMobility: TStringField;
    AccountGuestDatasetOtherNeeds: TStringField;
    AccountGuestDatasetEmergencyContactName: TStringField;
    AccountGuestDatasetEmergencyContactTelephone: TStringField;
    AccountGuestDatasetEmergencyContactRelation: TStringField;
    AccountGuestDatasetOrigAirport: TStringField;
    AccountGuestDatasetPrefAirline: TStringField;
    AccountGuestDatasetBoardRequired: TBooleanField;
    AccountGuestDatasetTotalPersonPrice: TFloatField;
    AccountGuestDatasetDepositDue: TFloatField;
    AccountGuestDatasetSameContactDetails: TBooleanField;
    AccountGuestDatasetOtherTravelRequirements: TStringField;
    AccountGuestDatasetTransportId: TIntegerField;
    ChangePasswordLink: TLabel;
    procedure AccountGuestDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure EmergencyDetailsLabelClick(Sender: TObject);
    procedure AccountGuestDatasetAfterOpen(Dataset: TDataSet);
    procedure ChangePasswordLinkClick(Sender: TObject);
    Procedure MyDetailsLinkClick(Sender: TObject);
    Procedure NewBookingLinkClick(Sender: TObject);
    Procedure SignOutLinkClick(Sender: TObject);
    Procedure TestLocalExceptionClick(Sender: TObject);
    Procedure TestServerExceptionClick(Sender: TObject);
    Procedure WebFormBeforeUnload(Sender: TObject; Var AMessage: String);
    Procedure WebFormCreate(Sender: TObject);
  Private
    { Private declarations }
    FFirstLoad: Boolean;
    FLastBooking: TBasicBookingInfo;
    Procedure OnUpdateForm(Sender: TObject);
    Procedure AfterLoadForm(Sender: TObject);
    [async]
    Procedure ShowMyBookings; async;
    [async]
    Procedure EditMyDetails; async;
    [async]
    Procedure TestAServerException; async;
    [async]
    Procedure CheckLastBooking; async;
    [async]
    procedure LoadEmergencyDetails; async;
    [async]
    procedure EditEmergencyDetails; async;
    [async]
    procedure LoadChangePassword; async;

  Protected
    [async]
    Procedure InitForm; async; Override;
    Procedure HandlePopState(State: TJSObject; Const AURL, AHash: String); Override;
  Public
    { Public declarations }
    Class Procedure DisplayPage(Const AElementId: String); Override;
  protected procedure LoadDFMValues; override; End;

Var
  AccountMainPage: TAccountMainPage;

Implementation

{$R *.dfm}

Uses
  System.DateUtils,
  XData.Web.Client,
  smx.webcore.Types,
  WebForm.Core,
  MainDataModule,
  AccountMyBookings,
  Booking.Web.Shared,
  AccountBaseForm,
  AccountCustomerDetails,
  AccountOtherDetails, XData.Dataset.Utils, AccountChangePassword;

procedure TAccountMainPage.AccountGuestDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
begin
  AccountGuestDataset.Close;
  AccountGuestDataset.QueryString := '';
end;

Procedure TAccountMainPage.WebFormCreate(Sender: TObject);
Begin
  Inherited;
  FFirstLoad := True;
  ShowMyBookings;
End;

{ TMainAccountPage }

Procedure TAccountMainPage.AfterLoadForm(Sender: TObject);
Begin
  If FFirstLoad Then
  Begin
    FFirstLoad := False;
    If MainData.IsFirstRegistration And (Not MainData.CustomerDetailsUpdated) Then
      EditMyDetails;
  End;
End;

procedure TAccountMainPage.CheckLastBooking;
Const
  last_booking_svc = 'ICustomerService.LastBooking';
Var
  lRetval: TXDataClientResponse;
  lResult: TJSObject;
  lBookingId: Integer;
Begin
  lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(last_booking_svc, [MainData.CustomerId]));
  lResult := lRetval.ResultAsObject;
  FLastBooking := TBasicBookingInfo.Create(lResult);
  lBookingId := FLastBooking.BookingId;

  EmergencyDetailsLabel.Visible := FLastBooking.CustomerId > 0;

end;

Class Procedure TAccountMainPage.DisplayPage(Const AElementId: String);
  Procedure AfterCreate(AForm: TObject);
  Begin
    // TMainPage(AForm).SetLabels;
  End;

Begin
  If Not Assigned(AccountMainPage) Then
  Begin
    AccountMainPage := TAccountMainPage.CreateNew(AElementId, @AfterCreate);
  End;
End;

procedure TAccountMainPage.LoadChangePassword;
var lForm: TChangePasswordForm;
    Retval: TModalResult;
begin
  lForm := TChangePasswordForm.Create(Self);
  try
    lForm.Popup := True;
    lForm.PopupOpacity := 1;
    Await(TForm, lForm.Load());
    lForm.ElementClassName := POPUP_FORM_CLASS;
    Retval := Await(TModalResult, lForm.Execute);
  finally
    lForm.Free;
    lForm := Nil;
  end;
end;

procedure TAccountMainPage.LoadEmergencyDetails;
begin
  AccountGuestDataset.QueryString := '$filter=BookingId eq ' + FLastBooking.BookingId.ToString +
    ' and CustomerId eq ' + FLastBooking.CustomerId.ToString;
  AccountGuestDataset.Load;
end;

procedure TAccountMainPage.EditEmergencyDetails;
Var
  lForm: TAccountOtherDetailsForm;
  Retval: TModalResult;
  lStartDate: TDate;
Begin
  lStartDate := FLastBooking.HolidayStartDate;
  lForm := TAccountOtherDetailsForm.Create(Self);
  Try
    lForm.Popup := True;
    lForm.PopupOpacity := 1;
    Await(TForm, lForm.Load());
    lForm.ElementClassName := POPUP_FORM_CLASS;
    lForm.Dataset := AccountGuestDataset;

    lForm.BookingActive := FLastBooking.StartDate > Today;
    Retval := Await(TModalResult, lForm.Execute);
    If (Retval = mrOK) And TXDataDsUtils.IsModified(AccountGuestDataset) Then
      AccountGuestDataset.ApplyUpdates
    else
    begin
      AccountGuestDataset.Close;
      AccountGuestDataset.QueryString := '';
    end;
  Finally
    lForm.Free;
    lForm := Nil;
  End;
end;

Procedure TAccountMainPage.EditMyDetails;
var
  lRetval: TModalResult;
begin
  if Assigned(FMainPagePopUpForm) then
  begin
    Console.error('A popup form (' + FMainPagePopUpForm.ClassName + ') is already created, so another (' +
      TMyDetails.ClassName + ') can''t be created here');
    Exit;
  end;

  lRetval := mrClose;
  FMainPagePopUpForm := TMyDetails.Create(Self);
  try
    FMainPagePopUpForm.Popup := True;
    FMainPagePopUpForm.PopupOpacity := 1;
    Await(TForm, FMainPagePopUpForm.Load());
    FMainPagePopUpForm.ElementClassName := POPUP_FORM_CLASS;
    TMyDetails(FMainPagePopUpForm).CustomerId := MainData.CustomerId;
    lRetval := Await(TModalResult, FMainPagePopUpForm.Execute);

  finally
    FMainPagePopUpForm.Free;
    FMainPagePopUpForm := nil;
  end;

  If lRetval = mrOK Then
    MainData.ReloadCustomer;

End;

procedure TAccountMainPage.EmergencyDetailsLabelClick(Sender: TObject);
begin
  LoadEmergencyDetails;
end;

procedure TAccountMainPage.AccountGuestDatasetAfterOpen(Dataset: TDataSet);
Begin
  EditEmergencyDetails;
end;

procedure TAccountMainPage.ChangePasswordLinkClick(Sender: TObject);
begin
  LoadChangePassword;
end;

Procedure TAccountMainPage.HandlePopState(State: TJSObject; Const AURL, AHash: String);
Var
  lHash: String;
Begin
  If AHash.StartsWith('Account') Then
  Begin
    If (FDisplayedForm Is TCoreWebForm) Then
    Begin
      lHash := TCoreWebForm(FDisplayedForm).PageHashName;
      If lHash = AHash Then
      Begin
        TCoreWebForm(FDisplayedForm).ClosePopUp;
        ClosePopUp;
      End;
    End;
  End
  Else If AHash.StartsWith('bp') Then
    MainData.SwitchMainPage(TMainAppPage.mpBooking)
End;

Procedure TAccountMainPage.InitForm;
Begin
  Inherited;
  Caption := Application_Title;
  MainData.ErrorMessageProc := ErrorHandler;
  Await(CheckLastBooking);
  OnUpdateForm(Self);
{$IFDEF DEBUG}
  TestLocalException.Visible := True;
  TestServerException.Visible := True;
{$ELSE}
  TestLocalException.Visible := False;
  TestServerException.Visible := False;
{$ENDIF}
End;

Procedure TAccountMainPage.MyDetailsLinkClick(Sender: TObject);
Begin
  EditMyDetails;
End;

Procedure TAccountMainPage.NewBookingLinkClick(Sender: TObject);
Begin
  MainData.SwitchMainPage(TMainAppPage.mpBooking);
End;

Procedure TAccountMainPage.OnUpdateForm(Sender: TObject);
Begin
  If MainData.IsActiveBooking Then
    NewBookingLink.Caption := 'Continue booking'
  Else
    NewBookingLink.Caption := 'Make a new booking';
End;

Procedure TAccountMainPage.ShowMyBookings;

  Procedure AfterFormCreated(AForm: TObject);
  Begin

    TCoreWebForm(AForm).OnSelfClose := OnFormSelfClose;
    TAccountMyBookingsPage(AForm).OnCloseCallback := OnUpdateForm;
    TAccountMyBookingsPage(AForm).AfterLoaded := AfterLoadForm;
    TCoreWebForm(AForm).AfterCreated;
    TAccountMyBookingsPage(AForm).InitForm;

    HideWaitMessage;
  End;

Begin
  If Assigned(FDisplayedForm) And (FDisplayedForm.ClassType = TAccountMyBookingsPage) Then
    Exit;

  If Not CloseDisplayedForm(True) Then
    Exit;

  Application.CreateForm(TAccountMyBookingsPage, 'MainPanel', FDisplayedForm, @AfterFormCreated);

End;

Procedure TAccountMainPage.SignOutLinkClick(Sender: TObject);
Begin
  MainData.Logout(TLogoutMethod.lomManual);

End;

Procedure TAccountMainPage.TestAServerException;
Const
  svc = 'IsmxSupportService.RaiseServerException';
Begin
  Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(svc, []));
End;

Procedure TAccountMainPage.TestLocalExceptionClick(Sender: TObject);
Begin
  Raise Exception.Create('Test Web Exception');
End;

Procedure TAccountMainPage.TestServerExceptionClick(Sender: TObject);
Begin
  TestAServerException;
End;

Procedure TAccountMainPage.WebFormBeforeUnload(Sender: TObject; Var AMessage: String);
Begin
  Inherited;
  CloseDisplayedForm;
  MainData.Logout(TLogoutMethod.lomBrowserClose);
  MainData.SwitchMainPage(TMainAppPage.mpBooking);
End;

procedure TAccountMainPage.LoadDFMValues;
begin
  inherited LoadDFMValues;

  NewBookingLink := TLabel.Create('NewBookingLink');
  SignOutLink := TLabel.Create('SignOutLink');
  MyDetailsLink := TLabel.Create('MyDetailsLink');
  TestServerException := TLabel.Create('TestServerException');
  TestLocalException := TLabel.Create('TestLocalException');
  EmergencyDetailsLabel := TLabel.Create('emergency-details-link');
  ChangePasswordLink := TLabel.Create('change-password-link');
  AccountGuestDataset := TXDataWebDataSet.Create(Self);
  AccountGuestDatasetGuestId := TIntegerField.Create(Self);
  AccountGuestDatasetCustomerId := TIntegerField.Create(Self);
  AccountGuestDatasetBookingId := TIntegerField.Create(Self);
  AccountGuestDatasetGuestType := TStringField.Create(Self);
  AccountGuestDatasetMedia1 := TStringField.Create(Self);
  AccountGuestDatasetMedia2 := TStringField.Create(Self);
  AccountGuestDatasetMedia3 := TStringField.Create(Self);
  AccountGuestDatasetMedia4 := TStringField.Create(Self);
  AccountGuestDatasetExtraNightsCharge := TFloatField.Create(Self);
  AccountGuestDatasetRoomTypeId := TIntegerField.Create(Self);
  AccountGuestDatasetRoomUpgradeDescription := TStringField.Create(Self);
  AccountGuestDatasetIncomplete := TBooleanField.Create(Self);
  AccountGuestDatasetGuestNumber := TIntegerField.Create(Self);
  AccountGuestDatasetEaselRequired := TBooleanField.Create(Self);
  AccountGuestDatasetFoldingChairRequired := TBooleanField.Create(Self);
  AccountGuestDatasetDietaryRequirements := TStringField.Create(Self);
  AccountGuestDatasetMobility := TStringField.Create(Self);
  AccountGuestDatasetOtherNeeds := TStringField.Create(Self);
  AccountGuestDatasetEmergencyContactName := TStringField.Create(Self);
  AccountGuestDatasetEmergencyContactTelephone := TStringField.Create(Self);
  AccountGuestDatasetEmergencyContactRelation := TStringField.Create(Self);
  AccountGuestDatasetOrigAirport := TStringField.Create(Self);
  AccountGuestDatasetPrefAirline := TStringField.Create(Self);
  AccountGuestDatasetBoardRequired := TBooleanField.Create(Self);
  AccountGuestDatasetTotalPersonPrice := TFloatField.Create(Self);
  AccountGuestDatasetDepositDue := TFloatField.Create(Self);
  AccountGuestDatasetSameContactDetails := TBooleanField.Create(Self);
  AccountGuestDatasetOtherTravelRequirements := TStringField.Create(Self);
  AccountGuestDatasetTransportId := TIntegerField.Create(Self);

  NewBookingLink.BeforeLoadDFMValues;
  SignOutLink.BeforeLoadDFMValues;
  MyDetailsLink.BeforeLoadDFMValues;
  TestServerException.BeforeLoadDFMValues;
  TestLocalException.BeforeLoadDFMValues;
  EmergencyDetailsLabel.BeforeLoadDFMValues;
  ChangePasswordLink.BeforeLoadDFMValues;
  AccountGuestDataset.BeforeLoadDFMValues;
  AccountGuestDatasetGuestId.BeforeLoadDFMValues;
  AccountGuestDatasetCustomerId.BeforeLoadDFMValues;
  AccountGuestDatasetBookingId.BeforeLoadDFMValues;
  AccountGuestDatasetGuestType.BeforeLoadDFMValues;
  AccountGuestDatasetMedia1.BeforeLoadDFMValues;
  AccountGuestDatasetMedia2.BeforeLoadDFMValues;
  AccountGuestDatasetMedia3.BeforeLoadDFMValues;
  AccountGuestDatasetMedia4.BeforeLoadDFMValues;
  AccountGuestDatasetExtraNightsCharge.BeforeLoadDFMValues;
  AccountGuestDatasetRoomTypeId.BeforeLoadDFMValues;
  AccountGuestDatasetRoomUpgradeDescription.BeforeLoadDFMValues;
  AccountGuestDatasetIncomplete.BeforeLoadDFMValues;
  AccountGuestDatasetGuestNumber.BeforeLoadDFMValues;
  AccountGuestDatasetEaselRequired.BeforeLoadDFMValues;
  AccountGuestDatasetFoldingChairRequired.BeforeLoadDFMValues;
  AccountGuestDatasetDietaryRequirements.BeforeLoadDFMValues;
  AccountGuestDatasetMobility.BeforeLoadDFMValues;
  AccountGuestDatasetOtherNeeds.BeforeLoadDFMValues;
  AccountGuestDatasetEmergencyContactName.BeforeLoadDFMValues;
  AccountGuestDatasetEmergencyContactTelephone.BeforeLoadDFMValues;
  AccountGuestDatasetEmergencyContactRelation.BeforeLoadDFMValues;
  AccountGuestDatasetOrigAirport.BeforeLoadDFMValues;
  AccountGuestDatasetPrefAirline.BeforeLoadDFMValues;
  AccountGuestDatasetBoardRequired.BeforeLoadDFMValues;
  AccountGuestDatasetTotalPersonPrice.BeforeLoadDFMValues;
  AccountGuestDatasetDepositDue.BeforeLoadDFMValues;
  AccountGuestDatasetSameContactDetails.BeforeLoadDFMValues;
  AccountGuestDatasetOtherTravelRequirements.BeforeLoadDFMValues;
  AccountGuestDatasetTransportId.BeforeLoadDFMValues;
  try
    NewBookingLink.SetParentComponent(Self);
    NewBookingLink.Name := 'NewBookingLink';
    NewBookingLink.Left := 32;
    NewBookingLink.Top := 200;
    NewBookingLink.Width := 136;
    NewBookingLink.Height := 18;
    NewBookingLink.Caption := 'Make a New Booking';
    NewBookingLink.ElementClassName := 'btn btn-primary';
    NewBookingLink.ElementFont := efCSS;
    NewBookingLink.ElementPosition := epIgnore;
    NewBookingLink.HeightStyle := ssAuto;
    NewBookingLink.HeightPercent := 100.000000000000000000;
    NewBookingLink.WidthStyle := ssAuto;
    NewBookingLink.WidthPercent := 100.000000000000000000;
    SetEvent(NewBookingLink, Self, 'OnClick', 'NewBookingLinkClick');
    SignOutLink.SetParentComponent(Self);
    SignOutLink.Name := 'SignOutLink';
    SignOutLink.Left := 32;
    SignOutLink.Top := 232;
    SignOutLink.Width := 55;
    SignOutLink.Height := 18;
    SignOutLink.Caption := 'Sign Out';
    SignOutLink.ElementClassName := 'btn btn-primary';
    SignOutLink.ElementFont := efCSS;
    SignOutLink.ElementPosition := epIgnore;
    SignOutLink.HeightStyle := ssAuto;
    SignOutLink.HeightPercent := 100.000000000000000000;
    SignOutLink.WidthPercent := 100.000000000000000000;
    SetEvent(SignOutLink, Self, 'OnClick', 'SignOutLinkClick');
    MyDetailsLink.SetParentComponent(Self);
    MyDetailsLink.Name := 'MyDetailsLink';
    MyDetailsLink.Left := 32;
    MyDetailsLink.Top := 272;
    MyDetailsLink.Width := 149;
    MyDetailsLink.Height := 18;
    MyDetailsLink.Caption := 'Update Contact Details';
    MyDetailsLink.ElementClassName := 'btn btn-primary';
    MyDetailsLink.ElementFont := efCSS;
    MyDetailsLink.ElementPosition := epIgnore;
    MyDetailsLink.HeightStyle := ssAuto;
    MyDetailsLink.HeightPercent := 100.000000000000000000;
    MyDetailsLink.WidthStyle := ssAuto;
    MyDetailsLink.WidthPercent := 100.000000000000000000;
    SetEvent(MyDetailsLink, Self, 'OnClick', 'MyDetailsLinkClick');
    TestServerException.SetParentComponent(Self);
    TestServerException.Name := 'TestServerException';
    TestServerException.Left := 32;
    TestServerException.Top := 384;
    TestServerException.Width := 144;
    TestServerException.Height := 18;
    TestServerException.Caption := 'Test Server Exception';
    TestServerException.ElementClassName := 'btn btn-primary';
    TestServerException.ElementFont := efCSS;
    TestServerException.ElementPosition := epIgnore;
    TestServerException.HeightStyle := ssAuto;
    TestServerException.HeightPercent := 100.000000000000000000;
    TestServerException.WidthPercent := 100.000000000000000000;
    SetEvent(TestServerException, Self, 'OnClick', 'TestServerExceptionClick');
    TestLocalException.SetParentComponent(Self);
    TestLocalException.Name := 'TestLocalException';
    TestLocalException.Left := 32;
    TestLocalException.Top := 408;
    TestLocalException.Width := 134;
    TestLocalException.Height := 18;
    TestLocalException.Caption := 'Test Local Exception';
    TestLocalException.ElementClassName := 'btn btn-primary';
    TestLocalException.ElementFont := efCSS;
    TestLocalException.ElementPosition := epIgnore;
    TestLocalException.HeightStyle := ssAuto;
    TestLocalException.HeightPercent := 100.000000000000000000;
    TestLocalException.WidthPercent := 100.000000000000000000;
    SetEvent(TestLocalException, Self, 'OnClick', 'TestLocalExceptionClick');
    EmergencyDetailsLabel.SetParentComponent(Self);
    EmergencyDetailsLabel.Name := 'EmergencyDetailsLabel';
    EmergencyDetailsLabel.Left := 32;
    EmergencyDetailsLabel.Top := 320;
    EmergencyDetailsLabel.Width := 136;
    EmergencyDetailsLabel.Height := 18;
    EmergencyDetailsLabel.Caption := 'Update Other Details';
    EmergencyDetailsLabel.ElementClassName := 'btn btn-primary';
    EmergencyDetailsLabel.ElementFont := efCSS;
    EmergencyDetailsLabel.ElementPosition := epIgnore;
    EmergencyDetailsLabel.HeightStyle := ssAuto;
    EmergencyDetailsLabel.HeightPercent := 100.000000000000000000;
    EmergencyDetailsLabel.WidthStyle := ssAuto;
    EmergencyDetailsLabel.WidthPercent := 100.000000000000000000;
    SetEvent(EmergencyDetailsLabel, Self, 'OnClick', 'EmergencyDetailsLabelClick');
    ChangePasswordLink.SetParentComponent(Self);
    ChangePasswordLink.Name := 'ChangePasswordLink';
    ChangePasswordLink.Left := 32;
    ChangePasswordLink.Top := 344;
    ChangePasswordLink.Width := 115;
    ChangePasswordLink.Height := 18;
    ChangePasswordLink.Caption := 'Change Password';
    ChangePasswordLink.ElementClassName := 'btn btn-primary';
    ChangePasswordLink.ElementFont := efCSS;
    ChangePasswordLink.ElementPosition := epIgnore;
    ChangePasswordLink.HeightStyle := ssAuto;
    ChangePasswordLink.HeightPercent := 100.000000000000000000;
    ChangePasswordLink.WidthStyle := ssAuto;
    ChangePasswordLink.WidthPercent := 100.000000000000000000;
    SetEvent(ChangePasswordLink, Self, 'OnClick', 'ChangePasswordLinkClick');
    AccountGuestDataset.SetParentComponent(Self);
    AccountGuestDataset.Name := 'AccountGuestDataset';
    AccountGuestDataset.AfterApplyUpdates := AccountGuestDatasetAfterApplyUpdates;
    AccountGuestDataset.AfterOpen := AccountGuestDatasetAfterOpen;
    AccountGuestDataset.EntitySetName := 'Guest';
    AccountGuestDataset.Connection := MainData.DataConnection;
    AccountGuestDataset.Left := 176;
    AccountGuestDataset.Top := 32;
    AccountGuestDatasetGuestId.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetGuestId.Name := 'AccountGuestDatasetGuestId';
    AccountGuestDatasetGuestId.FieldName := 'GuestId';
    AccountGuestDatasetCustomerId.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetCustomerId.Name := 'AccountGuestDatasetCustomerId';
    AccountGuestDatasetCustomerId.FieldName := 'CustomerId';
    AccountGuestDatasetBookingId.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetBookingId.Name := 'AccountGuestDatasetBookingId';
    AccountGuestDatasetBookingId.FieldName := 'BookingId';
    AccountGuestDatasetGuestType.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetGuestType.Name := 'AccountGuestDatasetGuestType';
    AccountGuestDatasetGuestType.FieldName := 'GuestType';
    AccountGuestDatasetGuestType.Size := 10;
    AccountGuestDatasetMedia1.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetMedia1.Name := 'AccountGuestDatasetMedia1';
    AccountGuestDatasetMedia1.FieldName := 'Media1';
    AccountGuestDatasetMedia1.Size := 12;
    AccountGuestDatasetMedia2.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetMedia2.Name := 'AccountGuestDatasetMedia2';
    AccountGuestDatasetMedia2.FieldName := 'Media2';
    AccountGuestDatasetMedia2.Size := 12;
    AccountGuestDatasetMedia3.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetMedia3.Name := 'AccountGuestDatasetMedia3';
    AccountGuestDatasetMedia3.FieldName := 'Media3';
    AccountGuestDatasetMedia3.Size := 12;
    AccountGuestDatasetMedia4.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetMedia4.Name := 'AccountGuestDatasetMedia4';
    AccountGuestDatasetMedia4.FieldName := 'Media4';
    AccountGuestDatasetMedia4.Size := 12;
    AccountGuestDatasetExtraNightsCharge.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetExtraNightsCharge.Name := 'AccountGuestDatasetExtraNightsCharge';
    AccountGuestDatasetExtraNightsCharge.FieldName := 'ExtraNightsCharge';
    AccountGuestDatasetRoomTypeId.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetRoomTypeId.Name := 'AccountGuestDatasetRoomTypeId';
    AccountGuestDatasetRoomTypeId.FieldName := 'RoomTypeId';
    AccountGuestDatasetRoomUpgradeDescription.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetRoomUpgradeDescription.Name := 'AccountGuestDatasetRoomUpgradeDescription';
    AccountGuestDatasetRoomUpgradeDescription.FieldName := 'RoomUpgradeDescription';
    AccountGuestDatasetRoomUpgradeDescription.Size := 1024;
    AccountGuestDatasetIncomplete.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetIncomplete.Name := 'AccountGuestDatasetIncomplete';
    AccountGuestDatasetIncomplete.FieldName := 'Incomplete';
    AccountGuestDatasetGuestNumber.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetGuestNumber.Name := 'AccountGuestDatasetGuestNumber';
    AccountGuestDatasetGuestNumber.FieldName := 'GuestNumber';
    AccountGuestDatasetEaselRequired.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetEaselRequired.Name := 'AccountGuestDatasetEaselRequired';
    AccountGuestDatasetEaselRequired.FieldName := 'EaselRequired';
    AccountGuestDatasetFoldingChairRequired.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetFoldingChairRequired.Name := 'AccountGuestDatasetFoldingChairRequired';
    AccountGuestDatasetFoldingChairRequired.FieldName := 'FoldingChairRequired';
    AccountGuestDatasetDietaryRequirements.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetDietaryRequirements.Name := 'AccountGuestDatasetDietaryRequirements';
    AccountGuestDatasetDietaryRequirements.FieldName := 'DietaryRequirements';
    AccountGuestDatasetDietaryRequirements.Size := 1024;
    AccountGuestDatasetMobility.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetMobility.Name := 'AccountGuestDatasetMobility';
    AccountGuestDatasetMobility.FieldName := 'Mobility';
    AccountGuestDatasetMobility.Size := 1024;
    AccountGuestDatasetOtherNeeds.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetOtherNeeds.Name := 'AccountGuestDatasetOtherNeeds';
    AccountGuestDatasetOtherNeeds.FieldName := 'OtherNeeds';
    AccountGuestDatasetOtherNeeds.Size := 1024;
    AccountGuestDatasetEmergencyContactName.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetEmergencyContactName.Name := 'AccountGuestDatasetEmergencyContactName';
    AccountGuestDatasetEmergencyContactName.FieldName := 'EmergencyContactName';
    AccountGuestDatasetEmergencyContactName.Size := 255;
    AccountGuestDatasetEmergencyContactTelephone.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetEmergencyContactTelephone.Name := 'AccountGuestDatasetEmergencyContactTelephone';
    AccountGuestDatasetEmergencyContactTelephone.FieldName := 'EmergencyContactTelephone';
    AccountGuestDatasetEmergencyContactTelephone.Size := 255;
    AccountGuestDatasetEmergencyContactRelation.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetEmergencyContactRelation.Name := 'AccountGuestDatasetEmergencyContactRelation';
    AccountGuestDatasetEmergencyContactRelation.FieldName := 'EmergencyContactRelation';
    AccountGuestDatasetEmergencyContactRelation.Size := 50;
    AccountGuestDatasetOrigAirport.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetOrigAirport.Name := 'AccountGuestDatasetOrigAirport';
    AccountGuestDatasetOrigAirport.FieldName := 'OrigAirport';
    AccountGuestDatasetOrigAirport.Size := 50;
    AccountGuestDatasetPrefAirline.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetPrefAirline.Name := 'AccountGuestDatasetPrefAirline';
    AccountGuestDatasetPrefAirline.FieldName := 'PrefAirline';
    AccountGuestDatasetPrefAirline.Size := 50;
    AccountGuestDatasetBoardRequired.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetBoardRequired.Name := 'AccountGuestDatasetBoardRequired';
    AccountGuestDatasetBoardRequired.FieldName := 'BoardRequired';
    AccountGuestDatasetTotalPersonPrice.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetTotalPersonPrice.Name := 'AccountGuestDatasetTotalPersonPrice';
    AccountGuestDatasetTotalPersonPrice.FieldName := 'TotalPersonPrice';
    AccountGuestDatasetDepositDue.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetDepositDue.Name := 'AccountGuestDatasetDepositDue';
    AccountGuestDatasetDepositDue.FieldName := 'DepositDue';
    AccountGuestDatasetSameContactDetails.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetSameContactDetails.Name := 'AccountGuestDatasetSameContactDetails';
    AccountGuestDatasetSameContactDetails.FieldName := 'SameContactDetails';
    AccountGuestDatasetOtherTravelRequirements.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetOtherTravelRequirements.Name := 'AccountGuestDatasetOtherTravelRequirements';
    AccountGuestDatasetOtherTravelRequirements.FieldName := 'OtherTravelRequirements';
    AccountGuestDatasetOtherTravelRequirements.Size := 255;
    AccountGuestDatasetTransportId.SetParentComponent(AccountGuestDataset);
    AccountGuestDatasetTransportId.Name := 'AccountGuestDatasetTransportId';
    AccountGuestDatasetTransportId.FieldName := 'TransportId';
  finally
    NewBookingLink.AfterLoadDFMValues;
    SignOutLink.AfterLoadDFMValues;
    MyDetailsLink.AfterLoadDFMValues;
    TestServerException.AfterLoadDFMValues;
    TestLocalException.AfterLoadDFMValues;
    EmergencyDetailsLabel.AfterLoadDFMValues;
    ChangePasswordLink.AfterLoadDFMValues;
    AccountGuestDataset.AfterLoadDFMValues;
    AccountGuestDatasetGuestId.AfterLoadDFMValues;
    AccountGuestDatasetCustomerId.AfterLoadDFMValues;
    AccountGuestDatasetBookingId.AfterLoadDFMValues;
    AccountGuestDatasetGuestType.AfterLoadDFMValues;
    AccountGuestDatasetMedia1.AfterLoadDFMValues;
    AccountGuestDatasetMedia2.AfterLoadDFMValues;
    AccountGuestDatasetMedia3.AfterLoadDFMValues;
    AccountGuestDatasetMedia4.AfterLoadDFMValues;
    AccountGuestDatasetExtraNightsCharge.AfterLoadDFMValues;
    AccountGuestDatasetRoomTypeId.AfterLoadDFMValues;
    AccountGuestDatasetRoomUpgradeDescription.AfterLoadDFMValues;
    AccountGuestDatasetIncomplete.AfterLoadDFMValues;
    AccountGuestDatasetGuestNumber.AfterLoadDFMValues;
    AccountGuestDatasetEaselRequired.AfterLoadDFMValues;
    AccountGuestDatasetFoldingChairRequired.AfterLoadDFMValues;
    AccountGuestDatasetDietaryRequirements.AfterLoadDFMValues;
    AccountGuestDatasetMobility.AfterLoadDFMValues;
    AccountGuestDatasetOtherNeeds.AfterLoadDFMValues;
    AccountGuestDatasetEmergencyContactName.AfterLoadDFMValues;
    AccountGuestDatasetEmergencyContactTelephone.AfterLoadDFMValues;
    AccountGuestDatasetEmergencyContactRelation.AfterLoadDFMValues;
    AccountGuestDatasetOrigAirport.AfterLoadDFMValues;
    AccountGuestDatasetPrefAirline.AfterLoadDFMValues;
    AccountGuestDatasetBoardRequired.AfterLoadDFMValues;
    AccountGuestDatasetTotalPersonPrice.AfterLoadDFMValues;
    AccountGuestDatasetDepositDue.AfterLoadDFMValues;
    AccountGuestDatasetSameContactDetails.AfterLoadDFMValues;
    AccountGuestDatasetOtherTravelRequirements.AfterLoadDFMValues;
    AccountGuestDatasetTransportId.AfterLoadDFMValues;
  end;
end;

End.
